import './social-network-buttons.scss';

const SOCIAL_FACEBOOK = 'facebook';
const SOCIAL_X = 'x';
const EMAIL = 'email';

const attribute_href = 'href';

/* SOCIAL NETWORK BUTTON */
class SocialNetworkButton extends HTMLElement {
  constructor() {
    super();

    const linkElement = this.querySelector('.js-social_network-button');

    if (!linkElement) {
      return;
    }

    const {
      type,
      url = Object.assign(new URL(document.location), { hash: '' }).href,
      text = (document.querySelector('meta[property="og:title"]') || this.fakeElement).getAttribute('content'),
      title = document.title
    } = linkElement.dataset;

    const sharerUrl = this.createSharerUrl(type, url, text, title);

    this.setLinkHrefAttribute(linkElement, sharerUrl);
  }

  createSharerUrl(type, url, text, title) {
    switch (type) {
      case SOCIAL_FACEBOOK:
        return this.createFacebookSharerUrl(url);

      case SOCIAL_X:
        return this.createXSharerUrl(text, title, url);

      case EMAIL:
        return this.createMailSharerUrl(text, url, title);
    }
    return '';
  }

  createFacebookSharerUrl(url) {
    return encodeURI(`https://www.facebook.com/sharer/sharer.php?u=${url}`);
  }

  createXSharerUrl(text, title, url) {
    return encodeURI(`https://x.com/share?text=${text || title}&url=${url}`);
  }

  createMailSharerUrl(text, url, title) {
    const sharerURL = new URL('mailto:');
    sharerURL.searchParams.set('body', text.replace('{0}', url));
    sharerURL.searchParams.set('subject', title);

    let value = sharerURL.href.replaceAll('+', '%20');
    return value;
  }

  setLinkHrefAttribute(link, uri) {
    link.setAttribute(attribute_href, uri);
  }

  fakeElement = {
    getAttribute() {
      return '';
    }
  };
}

customElements.get('f-social-network-button') || customElements.define('f-social-network-button', SocialNetworkButton);
